import { LayoutDashboard, Building2, TrendingUp, Filter, Settings, Wrench, Calendar, CreditCard } from "lucide-react";
import { NavLink, useLocation, Link } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { useAuth } from "@/supabase-auth";
import { SidebarProfileFooter } from "@/components/sidebar/SidebarProfileFooter";
import oneFormIconDark from "@/assets/oneform-icon-dark.svg";
import oneFormIconLight from "@/assets/oneform-icon-light.svg";
import { ADMIN_ROUTES } from "@/routes/routes";

const navItems = [
  { title: "Overview", url: ADMIN_ROUTES.overview, icon: LayoutDashboard },
  { title: "Organizations", url: ADMIN_ROUTES.organizations, icon: Building2 },
  { title: "Admin Billing", url: ADMIN_ROUTES.billing, icon: CreditCard },
  { title: "Events", url: ADMIN_ROUTES.events, icon: Calendar },
  { title: "Usage", url: ADMIN_ROUTES.usage, icon: TrendingUp },
  { title: "Funnel", url: ADMIN_ROUTES.funnel, icon: Filter },
  { title: "Diagnostics", url: ADMIN_ROUTES.diagnostics, icon: Wrench },
  { title: "Admin Settings", url: ADMIN_ROUTES.settings, icon: Settings },
];

export function AdminSidebar() {
  const { open } = useSidebar();
  const location = useLocation();
  const { session, profile } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  // Prepare user data for profile footer
  const fullName = profile?.full_name || session?.user?.email?.split('@')[0] || 'Admin';
  const email = profile?.email || session?.user?.email || '';
  const avatarUrl = profile?.avatar_url;

  return (
    <Sidebar collapsible="icon" className="flex h-dvh flex-col">
      <SidebarHeader className="border-b">
        <Link to={ADMIN_ROUTES.overview} className="flex items-center gap-2 px-4 py-3">
          <img src={oneFormIconDark} alt="OneForm" className="w-6 h-6 dark:hidden flex-shrink-0" />
          <img src={oneFormIconLight} alt="OneForm" className="w-6 h-6 hidden dark:block flex-shrink-0" />
          {open && <span className="font-semibold">OneForm Admin</span>}
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Administration</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <NavLink to={item.url} end>
                      <item.icon className="h-4 w-4" />
                      {open && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      {/* Profile footer pinned to bottom */}
      <div className="mt-auto px-3 pb-3">
        <SidebarProfileFooter
          fullName={fullName}
          email={email}
          avatarUrl={avatarUrl}
        />
      </div>
    </Sidebar>
  );
}
